import { useField } from 'formik';
import { AssistantChatKind } from 'shared/domains/apollo/generated/types';
import { RegularInput } from './RegularInput';
import { TabularInput } from './TabularInput';
export function ContentField() {
    const [field] = useField('kind');
    const { value } = field;
    if (value === AssistantChatKind.Tabular) {
        return <TabularInput />;
    }
    return <RegularInput />;
}
